<!-- 服务信息卡片 -->
<template>
  <div class="service-container">
    <template v-for="(item, index) in options" :key="index">
      <!-- oneItem当只有服务网点的时候但是option的长度为2时，控制一个卡片的宽度 -->
      <div
        v-if="shouldShowCard(item, index)"
        class="service-card"
        :class="{
          'one-item': options.length == 1 || oneItem,
          'two-item': options.length == 2,
          'item-1x': options.length % 3 == 0,
          'item-2x': options.length !== 1 && options.length % 3 == 1,
          'item-3x': options.length !== 2 && options.length % 3 == 2
        }"
        @click="emits('cardClick', item)">
        <div class="service-top">
          <svg-icon class="service-img" :name="item?.iconPc"></svg-icon>
          <div class="service-title">{{ $t(item?.name) }}</div>
          <div class="service-desc">
            {{ $t(item?.tips) }}
          </div>
        </div>
        <div class="service-apply">
          {{ $t(item?.buttonText) }}
        </div>
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
const emits = defineEmits(['cardClick']);
const route = useRoute();
const { subCategoryCode } = route.query;
const props = defineProps({
  options: {
    default: [],
    type: Array
  },
  isVehicle: {
    default: false,
    type: Boolean
  }
});

const oneItem = ref(false); // 用于控制第一个卡片的显示状态
// 判断卡片是否应该显示
function shouldShowCard(item: any, index: number) {
  // 只对第一个卡片应用特殊逻辑
  if (index === 0) {
    if (props.isVehicle === true) {
      // 当是车辆页面且subCategoryCode为F1时，第一个卡片不显示
      if (subCategoryCode === 'F1') {
        oneItem.value = true;
        return false;
      } else {
        return true;
      }
    }
  }
  // 对于其他卡片，始终显示
  return true;
}
</script>
<style lang="scss" scoped>
.service-container {
  width: 1200px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.service-card {
  width: 285px;
  // height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 16px 16px 30px;
  background: #f3f6fa;
  border-radius: 10px;
  margin-right: 20px;
  margin-bottom: 20px;
  &:last-child {
    margin-right: unset;
  }
  .service-top,
  .service-apply {
    text-align: center;
  }
  .service-img {
    width: 80px;
    height: 80px;
    margin-bottom: 24px;
  }
  .service-title {
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 8px;
  }
  .service-desc {
    min-height: 48px;
    word-wrap: break-word;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    opacity: 0.5;
  }
  .service-apply {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
  }
}
.service-card:hover {
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
  transform: translateY(-10px);
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  .service-apply {
    color: #157be1;
    text-decoration: underline;
  }
}
.service-card + .service-card {
  // margin-left: 20px;
}
.one-item {
  width: 1200px !important;
  margin-bottom: 0;
}
.two-item {
  width: 590px;
  margin-bottom: 0;
  &:nth-child(2n) {
    margin-right: unset;
  }
}
.item-1x {
  width: 385px;
  &:nth-child(3n) {
    margin-right: unset;
  }
}
.item-2x {
  width: 285px;
  &:nth-child(4n) {
    margin-right: unset;
  }
}
.item-3x {
  width: 385px;
  &:nth-child(3n) {
    margin-right: unset;
  }
}
</style>
